import { Box, Stack, SxProps, Typography } from "@mui/material";

import ShapeSticker from "@app/analytics/assets/shapes.png";
import { Link } from "@app/common/components/Link";
import ROUTES from "@app/common/routes";

const DEFAULT_TITLE = "There's nothing to report on here.";

const DefaultSubtitle = () => (
  <>
    Try adjusting the date range, or add Read to your{" "}
    <Link
      to={ROUTES.CALENDAR}
      sx={{
        color: "#282828",
        fontWeight: 400,
        textDecoration: "underline",
      }}
    >
      next calendar event
    </Link>{" "}
    to start populating data.
  </>
);

const NothingToReport = ({
  subtitle,
  sx,
  title = DEFAULT_TITLE,
}: {
  subtitle?: string;
  sx?: SxProps;
  title?: string;
}) => {
  return (
    <Stack
      direction="row"
      alignItems="center"
      justifyContent="center"
      sx={{
        bgcolor: "background.default",
        borderRadius: "16px",
        height: "100%",
        ...sx,
      }}
    >
      <Box sx={{ width: "80px" }} component="img" src={ShapeSticker} />
      <Stack sx={{ maxWidth: "350px" }}>
        <Typography
          variant="subtitle2"
          sx={{
            color: "shades.neutral.800",
            lineHeight: 24 / 14,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="subtitle2"
          sx={{
            color: "shades.neutral.800",
            fontWeight: 400,
            lineHeight: 24 / 14,
            maxWidth: "100%",
            whiteSpace: "break-spaces",
          }}
        >
          {subtitle ?? <DefaultSubtitle />}
        </Typography>
      </Stack>
    </Stack>
  );
};

export default NothingToReport;
